import React, { useState, useRef } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { createPageUrl } from '@/utils';
import { ArrowLeft, CreditCard, Upload, FileText, Download, TrendingDown, Copy } from 'lucide-react';
import { motion } from 'framer-motion';

export default function DespesasGeralZendry() {
  const [csvData, setCsvData] = useState([]);
  const [summary, setSummary] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [csvGerado, setCsvGerado] = useState(null); // Armazena dados do CSV gerado
  const [ofxData, setOfxData] = useState(null); // Dados do arquivo OFX
  const [conciliacaoResultado, setConciliacaoResultado] = useState(null); // Resultado da conciliação
  const [csvAuditoriaBase, setCsvAuditoriaBase] = useState(null);
  const [csvAuditoriaIA, setCsvAuditoriaIA] = useState(null);
  const [auditoriaCsvResultado, setAuditoriaCsvResultado] = useState(null);
  const [auditoriaFornecedoresDict, setAuditoriaFornecedoresDict] = useState(null);
  const fileInputRef = useRef(null);
  const ofxInputRef = useRef(null);
  const csvAuditoriaBaseRef = useRef(null);
  const csvAuditoriaIaRef = useRef(null);

  // Dicionário de fornecedores e seus códigos de conta débito
  const dicionarioFornecedores = {
    'SOFTWES LTDA': 5000023,
    'RATTS TECNOLOGIA': 5000022,
    'MIHEAL': 5000033, //Variação do nome
    'MIHAEL': 5000033,
    'NATALIA DE CASTRO': 5000470,
    'O3 VENUES': 5000374,
    'RODRIGO LOPES': 5000475,
    'ANNA CLARA BARROSO': 5000053,
    'DANIEL AZEVEDO': 5000382,
    'LEHI ALESSANDRO': 5000025,
    'LENI ALESSANDRO': 5000025, // Variação do nome
    'M A M LOPES': 5000030,
    'MURILO ANGELO MARQUES LOPES': 5000030, // Nome completo
    'HIGOR DA COSTA': 5000032,
    'TARCIS TAVARES': 5000041,
    'TARCIS TAVARES TOBIAS': 5000041, // Nome completo
    'LINSMAR MENEZES': 5000034,
    'LINSMAR MENEZES DA CRUZ': 5000034, // Nome completo
    'DEYVYSON OMENA': 5000042,
    'DEYVYSON OMENA HENRIQUE': 5000042, // Nome completo
    'PRISCILA GOMES': 5000281,
    'PRISCILA GOMES CORTES': 5000281, // Nome completo
    'ALAN CLEYTON': 5000036,
    'ALAN CLEYTON ALVES DA SILVA': 5000036, // Nome completo
    'WALTER MATHEUS': 5000355,
    'WALTER MATHEUS CRISOSTOMO ALVES': 5000355, // Nome completo
    'DANIEL SERGIO': 5000037,
    'DANIEL SERGIO DA SILVA': 5000037, // Nome completo
    'JOICE COSTA': 5000051,
    'JOICE COSTA RODRIGUES': 5000051, // Nome completo
    'DANIELE MEDEIROS': 5000039,
    'DANIELE MEDEIROS PAULA LIMA': 5000039, // Nome completo
    'MARCELO S. MOREIRA': 5000021,
    'MARCELO S MOREIRA': 5000021, // Sem ponto
    'MARIA CLARA BARRETO': 5000035,
    'MARIA CLARA BARRETO ALENCAR COELHO MOTA': 5000035, // Nome completo
    'ALEX ARAUJO DOMINGOS': 5000049,
    'ALEX ARAUJO': 5000049,
    'EMILLY MARIA': 5000048,
    'EMILLY MARIA DA SILVA ARAUJO': 5000048, // Nome completo
    'WAGNER ROMEIRO': 5000046,
    'WAGNER ROMEIRO DA SILVA': 5000046, // Nome completo
    'EDUARDO CARLOS': 5000047,
    'EDUARDO CARLOS PRAXEDES': 5000047,
    'EDUARDO CARLOS PRAXEDES DO NASCIMENTO': 5000047, // Nome completo
    'RUTIELLE JORDANIA': 5000050,
    'JOSE BUARQUE': 5000045,
    'BARROS & MIRANDA': 5000278,
    'BARROS E MIRANDA': 5000278, // Variação
    'SA CONSULTORIA': 5000054,
    'SA ASSESSORIA': 5000054,
    'NOTAZZ GESTAO': 5000027,
    'OPS TEAM': 5000026,
    'RECEITA FEDERAL CSLL': 1553,
    'RECEITA FEDERAL IRPJ': 1545,
    'WANZIN LTDA': 5000279,
    'LOJA IMPERADOR': 5000366,
    'NN REFORMAS E SERVICOS': 5000375,
    'NN SOLUCOES TECNOLOGICAS': 5000375, // Variação
    'RECEITA FEDERAL PIS': 1556,
    'RECEITA FEDERAL COFINS': 1552,
    'EBAZAR.COM.BR. LTDA': 5000273,
    'EBAZAR.COM.BR LTDA': 5000273, // Sem ponto
    'EBAZAR': 5000273, // Forma curta
    'ROCHA E LEITE VIDRACARIA LTDA': 5000369,
    'RECEITA FEDERAL PARCELAMENTO': 4674,
    'PM SAO PAULO ISS': 1547,
    'MAXWELL DA SILVA DE BRITO LTDA': 5000378,
    'MAXWELL DA SILVA DE BRITO': 5000378, // Sem LTDA
    'ESTOK COMERCIO E REPRESENTACOES S/A': 5000372,
    'ESTOK DISTRIBUIDORA E SERVICOS S.A': 5000371, // Variação
    'ESTOK': 5000372, // Forma curta
    'CARAJAS MATERIAL DE CONSTRUCAO LTDA - MATRIZ': 5000380,
    'CARAJAS MATERIAL DE CONSTRUCAO LTDA': 5000380, // Sem MATRIZ
    'CARAJAS': 5000380, // Forma curta
    'MASTER ELETRONICA E BRINQUEDOS LTDA': 5000368,
    'IMPERADOR COMERCIO VAREJISTA E ATACADISTA LTDA': 5000366,
    'VM PARRAS FILIAL': 5000367,
    'CRIVEPEL LIVRARIA  PAPELARIA E INFORMATICA LTDA': 5000360,
    'KAMELEON BAG COMERCIO DE MALAS LTDA': 5000362,
    'BORDADOS BRESSER': 5000358,
    'XDREAM COMERCIO E MANUTENCAO LTDA': 5000364,
    'SMARTBUY COMERCIO VAREJISTA SA.': 5000361,
    'PACTO IMPORTADORA E DISTRIUDORA LTDA': 5000363,
    'DRI+ COMERCIO DE PRODUTOS IMPORTADOS LTDA': 5000365,
    'TRIBUTOS FEDERAIS': 0, // Genérico para tributos
    'DARF': 0, // Genérico para DARF
    'JANE MARCIA DE OLIVEIRA MELO FERREIR': 5000282,
    'MIRELLY GEOVANA DA SILVA LIRA': 5000356,
    'JOSE WILLAMS CAVALCANTE DA SILVA': 5000359,
    'DAYANA BOMFIM CAVALCANTI': 5000383,
    'WILLIAM FEITOSA ALVES DOS SANTOS': 5000384,
    'VANESSA BARBOSA DOS SANTOS': 5000052,
    'ELISANGELA SEMIAO LUIZ': 5000044,
    'PEDRO HENRIQUE MOURA OLIVEIRA DA SILVA': 5000357,
    'A R B PRODUTOS & SERVICOS FINANCEIROS LTDA': 5000038,
    'A.C. MILIONI PRODUTOS PROMOCIONAIS LTDA': 5000381,
    'BATTAGLIA & VIDILLI SOCIEDADE DE ADVOGADOS': 5000028,
    'ELOS DESENVOLVIMENTO HUMANO LTDA': 5000385,
    'ESTOK COMERCIO ATACADISTA LTDA': 5000373,
    'ESTOK DISTRIBUIDORA E SERVICOS SA': 5000371, // Atenção: No seu dict antigo, este nome estava vinculado ao 5000372
    'FABRICA TIRADENTES CAFE LTDA': 5000269,
    'FAST SIGN LTDA': 5000376,
    'FAST SIGN': 5000376,
    'Fornecedores Diversos': 1496,
    'FRIGELAR COMERCIO E INDUSTRIA LTDA': 5000377,
    'GRANDE NORDESTE COMERCIO DE MOVEIS LTDA - MACEIO': 5000370,
    'MRC COMMERCE': 5000386,
    'STARTSE INFORMACOES & SISTEMAS S/A': 5000029,
    'V B MOVEIS E ELTROS LTDA': 5000379,
    'TOK STOK CD SERRA ES': 5000372, // Nome específico usado neste balancete para este ID
    'DANIEL AZEVEDO DE ARAUJO MARQUES': 5000382, // Nome completo
    'DANIELE MEDEIROS SERVICOS ADMINISTRATIVOS LTDA': 5000039, // Razão Social (Dict tinha nome PF)
    'ALEX ARAUJO DOMINGOS DA SILVA': 5000049, // Nome completo
    'RUTIELLE JORDANIA DA SILVA': 5000050, // Nome completo
    'JOSE BUARQUE DOS SANTOS NETTO': 5000045, // Nome completo
    // --- Novos Fornecedores Identificados no Balancete 09/2025 ---
    'ELETRO 2 IMPORTACAO E VAREJO LTDA': 5000480,
    'FRONTERO PRODUTORA AUDIOVISUAL LTDA': 5000481,
    'GRUPO CASAS BAHIA SA': 5000477,
    'HUBI KITS E BRINDES CORPORATIVOS LTDA.': 5000479,
    'LZ COMUNICACAO VISUAL LTDA': 5000472,
    'MAGAZINE LUIZA S/A': 5000474,
    'NATHALIA SILVA DE SOUSA 46738269811': 5000473,
    'R A DE SOUZA E SILVA ME': 5000471,
    'SMART CHOICE MULTISTORE LTDA': 5000476,
    'VIP CAPAS LTDA': 5000478,
    // --- Variações de Nomes (IDs já existentes mas com Razão Social completa) ---
    'NATALIA DE CASTRO TEIXEIRA': 5000470, // Dicionário anterior tinha apenas "NATALIA DE CASTRO"
    'RODRIGO LOPES BALTAR DA SILVA PRODUCOES - ME': 5000475, // Dicionário anterior tinha apenas "RODRIGO LOPES"
    // --- Novos Fornecedores Identificados no Balancete 10/2025 ---
    'ALLAN DENIS DIAS': 5000485,
    'TAISLAN FRANCA VILAR DOS SANTOS': 5000484,
    'ARNALDO BARBOSA DA SILVA FILHO': 5000482,
    'ARJES CONFECCOES LTDA': 5000488,
    'AURA COMERCIO DE BRINDES PERSONALIZADOS LTDA': 5000493,
    'ELDORA FASHION LTDA': 5000492,
    'HALLINGER CONFECCOES EIRELI': 5000490,
    'Lenovo Tecnologia Brasil Ltda': 5000489,
    'MADEBRAS ATACADO DE MADEIRAS LTDA': 5000487,
    'MADEIRAS DO BRASIL LTDA': 5000483,
    'PERSONALIZE AGUA - EIRELI': 5000491,
    'RSM COMERCIO E CONFECCOES LTDA': 5000494,
    'RSM COMERCIO E CONFEC': 5000494, // Variação
    'STAR MIDIA E CAFE LTDA': 5000486,
    // --- Variações e Correções ---
    'PACTO IMPORTADORA E DISTRIBUIDORA LTDA': 5000363, // No dicionário original estava escrito "DISTRIUDORA" (sem o B)
    // --- Novos Fornecedores Identificados no Balancete 11/2025 ---
    'RAFAEL MAURICIO DA COSTA': 5000765,
    'ANE KERCIA SANTOS OLIVEIRA': 5000763,
    'ANDRE MEDEIROS TOLEDO - CNPJ: 45.572.724/0001-48 -': 5000762,
    'DNA COPOS PERSONALIZADOS LTDA': 5000768,
    'ENCANTO DO TEAR LTDA': 5000769,
    'FORUM NEGOCIOS LTDA': 5000761,
    'GLOBAL DISTRIBUICAO DE BENS DE CONS LTDA.': 5000767,
    'MATEUS SUPERMERCADOS S A': 5000766,
    // --- Contas Novas / Variações de Entidades Existentes ---
    'ANNA CLARA BARROSO': 5000764, // OBS: Este ID é para o nome SEM CPF. O nome COM CPF continua sendo 5000053.
  };

  const handleCSVAuditoriaBaseUpload = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const result = processarCSVAuditoria(e.target.result);
        setCsvAuditoriaBase(result);
      } catch (error) {
        console.error('Erro ao processar CSV gerado:', error);
        alert('Erro ao processar o CSV gerado. Verifique o formato do arquivo.');
      }
    };
    reader.readAsText(file, 'UTF-8');
  };

  const handleCSVAuditoriaIaUpload = (file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const result = processarCSVAuditoria(e.target.result);
        setCsvAuditoriaIA(result);
      } catch (error) {
        console.error('Erro ao processar CSV reescrito:', error);
        alert('Erro ao processar o CSV reescrito. Verifique o formato do arquivo.');
      }
    };
    reader.readAsText(file, 'UTF-8');
  };

  // Lista de setores esperados (normalizados - sem acentos)
  const setoresEsperados = [
    'TI',
    'MARKETING', 
    'OPERACIONAL',
    'ESTRATEGICO COMPARTILHADO',
    'COMERCIAL',
    'PRODUTOS',
    'CUSTO OPERACIONAL',
    'FINANCEIRO',
    'ATENDIMENTO',
    'EXPANSAO INTERNACIONAL',
    'DIRECAO',
    'JURIDICO',
    'ADMINISTRATIVO'
  ];

  // Função para fazer parsing robusto de CSV com campos multiline
  const parseCSVLine = (text, delimiter = ';') => {
    const result = [];
    let current = '';
    let inQuotes = false;
    let i = 0;
    
    while (i < text.length) {
      const char = text[i];
      const nextChar = text[i + 1];
      
      if (char === '"') {
        if (inQuotes && nextChar === '"') {
          // Aspas duplas escapadas
          current += '"';
          i += 2;
        } else {
          // Início ou fim de campo com aspas
          inQuotes = !inQuotes;
          i++;
        }
      } else if (char === delimiter && !inQuotes) {
        // Delimitador fora de aspas - fim do campo
        result.push(current);
        current = '';
        i++;
      } else {
        // Caractere normal
        current += char;
        i++;
      }
    }
    
    // Adicionar último campo
    result.push(current);
    return result;
  };

  const normalizarDataParaChave = (data) => {
    if (!data) return '';
    const matchBr = data.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if (matchBr) {
      return `${matchBr[3]}${matchBr[2]}${matchBr[1]}`;
    }
    const matchSemBarra = data.match(/(\d{2})(\d{2})(\d{4})/);
    if (matchSemBarra) {
      return `${matchSemBarra[3]}${matchSemBarra[2]}${matchSemBarra[1]}`;
    }
    const matchOfx = data.match(/(\d{4})(\d{2})(\d{2})/);
    if (matchOfx) {
      return `${matchOfx[1]}${matchOfx[2]}${matchOfx[3]}`;
    }
    return data;
  };

  const parseValorAuditoria = (valorStr) => {
    if (!valorStr) return 0;
    const valorLimpo = valorStr.includes(',')
      ? valorStr.replace(/\./g, '').replace(',', '.')
      : valorStr;
    return parseFloat(valorLimpo) || 0;
  };

  const processarCSVAuditoria = (conteudo) => {
    const linhas = conteudo.replace(/\r\n/g, '\n').replace(/\r/g, '\n')
      .split('\n')
      .filter(line => line.trim());
    const transacoes = [];

    linhas.forEach((linha) => {
      const campos = parseCSVLine(linha, ',');
      if (campos.length >= 6) {
        const dataBruta = (campos[0] || '').trim();
        const valorBruto = (campos[3] || '').trim();
        const descricaoBruta = (campos[5] || '').trim();
        const descricao = descricaoBruta.replace(/^"|"$/g, '');
        const dataFormatada = dataBruta.length === 8
          ? `${dataBruta.substring(0, 2)}/${dataBruta.substring(2, 4)}/${dataBruta.substring(4, 8)}`
          : dataBruta;
        const valor = parseValorAuditoria(valorBruto);
        const valorAbs = Math.abs(valor);
        const descricaoNormalizada = removerAcentosEMaiusculo(descricao);

        transacoes.push({
          data: dataFormatada,
          dataKey: normalizarDataParaChave(dataFormatada),
          valor,
          valorAbs,
          descricao,
          descricaoNormalizada
        });
      }
    });

    const totalValor = transacoes.reduce((sum, item) => sum + item.valorAbs, 0);
    return { transacoes, totalValor };
  };

  const copiarListaDivergencias = (itens) => {
    const texto = itens
      .map((item) => `${item.data};${item.valorAbs.toFixed(2)};${item.descricao || ''}`)
      .join('\n');

    navigator.clipboard.writeText(texto)
      .catch(() => undefined);
  };

  // Função para processar CSV
  const processCSV = (content) => {
    // Normalizar quebras de linha
    const normalizedContent = content.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
    
    // Fazer parsing considerando campos multiline
    const records = [];
    let currentRecord = '';
    let inQuotes = false;
    
    const lines = normalizedContent.split('\n');
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i];
      
      if (currentRecord) {
        currentRecord += '\n' + line;
      } else {
        currentRecord = line;
      }
      
      // Contar aspas para determinar se estamos dentro de um campo
      const quoteCount = (currentRecord.match(/"/g) || []).length;
      inQuotes = quoteCount % 2 !== 0;
      
      if (!inQuotes && currentRecord.trim()) {
        // Registro completo
        const fields = parseCSVLine(currentRecord);
        if (fields.length >= 25) {
          records.push(fields);
        }
        currentRecord = '';
      }
    }
    
    // Processar último registro se existir
    if (currentRecord.trim()) {
      const fields = parseCSVLine(currentRecord);
      if (fields.length >= 25) {
        records.push(fields);
      }
    }
    
    console.log(`📊 PROCESSANDO CSV DESPESAS:`);
    console.log(`📄 Total de registros encontrados: ${records.length}`);
    
    if (records.length < 2) {
      throw new Error('CSV deve conter pelo menos uma linha de cabeçalho e uma linha de dados');
    }

    const data = [];
    let totalGeral = 0;
    
    // Pular cabeçalho (primeiro registro)
    for (let i = 1; i < records.length; i++) {
      const values = records[i];
      
      // Verificar se a linha tem dados válidos
      // Verificar se tem data de movimento e valor válido
      const dataMovimento = values[0] && values[0].trim();
      const valorStr = values[9] && values[9].trim();
      const tipoOperacao = values[6] && values[6].trim();
      
      // Pular linhas vazias ou sem dados essenciais
      if (!dataMovimento || !valorStr || valorStr === '0' || valorStr === '0,00') {
        console.log(`⚠️ Pulando linha ${i} - dados inválidos:`, {
          data: dataMovimento,
          valor: valorStr,
          fornecedor: values[2]
        });
        continue;
      }
      
      const tipoOperacaoNormalizado = removerAcentosEMaiusculo(tipoOperacao);

      if (tipoOperacaoNormalizado.includes('CREDITO')) {
        console.log(`⚠️ Pulando linha ${i} - tipo de operação crédito:`, tipoOperacao);
        continue;
      }

      // Extrair campos conforme estrutura do CSV
      const valor = parseFloat(valorStr.replace(/\./g, '').replace(',', '.'));
      
      // Pular se valor é 0 ou inválido
      if (isNaN(valor) || valor === 0) {
        console.log(`⚠️ Pulando linha ${i} - valor inválido:`, valor);
        continue;
      }
      
      // Considerar apenas despesas (valores negativos)
      if (valor > 0) {
        console.log(`⚠️ Pulando linha ${i} - valor positivo (não é despesa):`, valorStr);
        continue;
      }
      
      // Verificar se deve ignorar linhas com PRIMEPAG (transferências entre bancos) - apenas para C6 Bank
      const descricaoLinha = values[4] || '';
      const contaBancaria = values[7] || '';
      const nomeFornecedorLinha = values[2] || '';
      const descricaoUpper = descricaoLinha.toUpperCase();
      const contaBancariaUpper = contaBancaria.toUpperCase();
      const fornecedorUpper = nomeFornecedorLinha.toUpperCase();
      
      const linhaEhC6Bank = contaBancariaUpper.includes('C6 BANK') || contaBancariaUpper.includes('C6BANK');
      
      if (linhaEhC6Bank) {
        const temPrimepagDescricao = descricaoUpper.includes('PRIMEPAG');
        const temPrimepagConta = contaBancariaUpper.includes('PRIMEPAG');
        const ehReceitaFederal = fornecedorUpper.includes('RECEITA FEDERAL');
        
        console.log(`🔍 Verificando linha ${i} - C6 Bank, PRIMEPAG na descrição: ${temPrimepagDescricao}, PRIMEPAG na conta: ${temPrimepagConta}, Receita Federal: ${ehReceitaFederal}`);
        
        // Filtrar PRIMEPAG, MAS NÃO se for RECEITA FEDERAL (pagamento de impostos)
        if ((temPrimepagDescricao || temPrimepagConta) && !ehReceitaFederal) {
          console.log(`❌ IGNORANDO linha ${i} - Contém PRIMEPAG (C6 Bank)`);
          console.log(`   Descrição: ${descricaoLinha.substring(0, 60)}`);
          console.log(`   Conta: ${contaBancaria.substring(0, 60)}`);
          continue;
        }
        
        // Se for RECEITA FEDERAL com PRIMEPAG, permitir (é pagamento de imposto, não transferência)
        if ((temPrimepagDescricao || temPrimepagConta) && ehReceitaFederal) {
          console.log(`✅ PERMITINDO linha ${i} - RECEITA FEDERAL (pagamento de imposto via PRIMEPAG)`);
        }
      }
      
      const row = {
        dataMovimento: dataMovimento,
        identificadorFornecedor: values[1] || '',
        nomeFornecedor: values[2] || '',
        recorrencia: values[3] || '',
        descricao: values[4] || '',
        agendado: values[5] || '',
        tipoOperacao: values[6] || '',
        contaBancaria: values[7] || '',
        formaPagamento: values[8] || '',
        valor: valor,
        saldoConta: parseFloat((values[10] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        situacao: values[11] || '',
        valorOriginal: parseFloat((values[12] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        juros: parseFloat((values[13] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        multa: parseFloat((values[14] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        desconto: parseFloat((values[15] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        taxas: parseFloat((values[16] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        dataCompetencia: values[17] || '',
        dataOriginalVencimento: values[18] || '',
        dataPrevista: values[19] || '',
        observacoes: values[20] || '',
        categoria1: values[21] || '',
        valorCategoria1: parseFloat((values[22] || '0').replace(/\./g, '').replace(',', '.')) || 0,
        centroCusto1: values[23] || '',
        valorCentroCusto1: parseFloat((values[24] || '0').replace(/\./g, '').replace(',', '.')) || 0
      };

      data.push(row);
      totalGeral += Math.abs(row.valor);

      if (i <= 5) {
        console.log(`📝 Linha ${i}:`, {
          fornecedor: row.nomeFornecedor,
          valor: row.valor,
          setor: row.centroCusto1,
          categoria: row.categoria1
        });
      }
    }

    console.log('💰 Total geral:', totalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2 }));
    console.log('📊 Registros processados:', data.length);

    return { data, totalGeral };
  };

  // Função para calcular totais por setor
  const calcularTotaisPorSetor = () => {
    if (!csvData.length) return [];

    const totaisPorSetor = {};
    const totalGeral = csvData.reduce((sum, row) => sum + Math.abs(row.valor), 0);

    // Inicializar todos os setores com 0 (já normalizados)
    setoresEsperados.forEach(setor => {
      totaisPorSetor[setor] = 0;
    });
    
    // Adicionar setor para não classificados
    totaisPorSetor['NAO CLASSIFICADO'] = 0;

    // Somar valores por setor
    csvData.forEach((row, index) => {
      const setorOriginal = row.centroCusto1 || 'NAO CLASSIFICADO';
      // Normalizar o nome do setor removendo acentos e caracteres especiais
      const setor = setorOriginal ? removerAcentosEMaiusculo(setorOriginal) : 'NAO CLASSIFICADO';
      const valor = Math.abs(row.valor);
      
      // Debug: mostrar alguns exemplos da normalização
      if (index < 5) {
        console.log(`🔄 Setor ${index + 1}: "${setorOriginal}" -> "${setor}"`);
      }
      
      if (totaisPorSetor.hasOwnProperty(setor)) {
        totaisPorSetor[setor] += valor;
      } else {
        totaisPorSetor[setor] = valor;
      }
    });

    // Converter para array e ordenar por valor (maior para menor)
    const setoresOrdenados = Object.entries(totaisPorSetor)
      .map(([setor, valor]) => ({
        setor,
        valor,
        percentual: totalGeral > 0 ? (valor / totalGeral) * 100 : 0
      }))
      .sort((a, b) => b.valor - a.valor)
      .filter(item => item.valor > 0); // Remover setores com valor 0

    console.log('📊 Setores calculados:', setoresOrdenados.map(s => s.setor));
    
    return setoresOrdenados;
  };

  // Função para formatar valor monetário
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(Math.abs(value));
  };

  // Função para formatar data no formato DDMMAAAA
  const formatarDataCSV = (dataOriginal) => {
    // Exemplo: "01/05/2025" -> "01052025"
    const match = dataOriginal.match(/(\d{2})\/(\d{2})\/(\d{4})/);
    if (match) {
      return `${match[1]}${match[2]}${match[3]}`;
    }
    return '01012024'; // Fallback
  };

  // Função para extrair competência do CSV (MMAAAA)
  const extrairCompetencia = () => {
    if (!csvData.length) {
      return '012024'; // Fallback
    }
    
    // Pegar a primeira transação para extrair mês/ano
    const primeiraData = csvData[0].dataMovimento;
    const match = primeiraData.match(/\d{2}\/(\d{2})\/(\d{4})/);
    
    if (match) {
      const mes = match[1];
      const ano = match[2];
      return `${mes}${ano}`;
    }
    
    return '012024'; // Fallback
  };

  // Função para remover acentos e converter para maiúsculo
  const removerAcentosEMaiusculo = (texto) => {
    return (texto || '')
      .normalize('NFD') // Decompor caracteres acentuados
      .replace(/[\u0300-\u036f]/g, '') // Remover diacríticos (acentos)
      .replace(/,/g, '') // Remover vírgulas
      .replace(/[^\x20-\x7E]/g, '')
      .toUpperCase(); // Converter para maiúsculo
  };

  const normalizarFornecedorParaMatch = (nomeFornecedor) => {
    const fornecedorNormalizadoRaw = removerAcentosEMaiusculo(nomeFornecedor);
    return fornecedorNormalizadoRaw.replace(/\bSERVIOS\b/g, 'SERVICOS');
  };

  // Função para determinar código da conta débito baseado no fornecedor
  const determinarContaDebito = (nomeFornecedor, categoria = '', descricao = '') => {
    const descricaoNormalizada = removerAcentosEMaiusculo(descricao);
    const categoriaNormalizada = removerAcentosEMaiusculo(categoria);

    // Regra especial: Pix recusado ou estorno
    if (
      descricaoNormalizada.includes('PIX RECUSADO') ||
      descricaoNormalizada.includes('ESTORNO') ||
      categoriaNormalizada.includes('ESTORNO')
    ) {
      console.log('✅ PIX RECUSADO/ESTORNO detectado -> Código 4866');
      return 4866;
    }

    if (!nomeFornecedor) return 0;
    
    // Normalizar o nome do fornecedor
    const fornecedorNormalizado = normalizarFornecedorParaMatch(nomeFornecedor);
    
    // Lógica especial para RECEITA FEDERAL - verificar categoria ou descrição
    if (fornecedorNormalizado === 'RECEITA FEDERAL') {
      
      // PRIORIDADE 1: Verificar PARCELAMENTO na descrição primeiro
      if (descricaoNormalizada.includes('PARCELAMENTO')) {
        console.log(`✅ RECEITA FEDERAL - Descrição PARCELAMENTO -> Código 4674`);
        return 4674;
      }
      
      // PRIORIDADE 2: Verificar na categoria
      if (categoriaNormalizada.includes('CSLL')) {
        console.log(`✅ RECEITA FEDERAL - Categoria CSLL -> Código 1553`);
        return 1553;
      }
      if (categoriaNormalizada.includes('IRPJ') || categoriaNormalizada.includes('IRRF')) {
        console.log(`✅ RECEITA FEDERAL - Categoria IRPJ/IRRF -> Código 1545`);
        return 1545;
      }
      if (categoriaNormalizada.includes('PIS')) {
        console.log(`✅ RECEITA FEDERAL - Categoria PIS -> Código 1556`);
        return 1556;
      }
      if (categoriaNormalizada.includes('COFINS')) {
        console.log(`✅ RECEITA FEDERAL - Categoria COFINS -> Código 1552`);
        return 1552;
      }
      
      // PRIORIDADE 3: Se não encontrou na categoria, verificar outros termos na descrição
      if (descricaoNormalizada.includes('CSLL')) {
        console.log(`✅ RECEITA FEDERAL - Descrição CSLL -> Código 1553`);
        return 1553;
      }
      if (descricaoNormalizada.includes('IRPJ') || descricaoNormalizada.includes('IRRF')) {
        console.log(`✅ RECEITA FEDERAL - Descrição IRPJ/IRRF -> Código 1545`);
        return 1545;
      }
      if (descricaoNormalizada.includes('PIS')) {
        console.log(`✅ RECEITA FEDERAL - Descrição PIS -> Código 1556`);
        return 1556;
      }
      if (descricaoNormalizada.includes('COFINS')) {
        console.log(`✅ RECEITA FEDERAL - Descrição COFINS -> Código 1552`);
        return 1552;
      }
      
      // Se não encontrou especificação, retornar 0
      console.log(`⚠️ RECEITA FEDERAL sem especificação de imposto -> Código 0`);
      return 0;
    }
    
    // Lógica especial para PM SAO PAULO - verificar categoria ISS
    if (fornecedorNormalizado === 'PM SAO PAULO') {
      const categoriaNormalizada = removerAcentosEMaiusculo(categoria);
      const descricaoNormalizada = removerAcentosEMaiusculo(descricao);
      
      // Verificar se é ISS na categoria ou descrição
      if (categoriaNormalizada.includes('ISS') || descricaoNormalizada.includes('ISS')) {
        console.log(`✅ PM SAO PAULO - ISS -> Código 1547`);
        return 1547;
      }
      
      // Se não especificou ISS, retornar 0
      console.log(`⚠️ PM SAO PAULO sem especificação de ISS -> Código 0`);
      return 0;
    }
    
    // Procurar correspondência exata primeiro
    if (dicionarioFornecedores[fornecedorNormalizado]) {
      return dicionarioFornecedores[fornecedorNormalizado];
    }
    
    // Procurar correspondência parcial (se o nome do fornecedor contém alguma chave do dicionário)
    for (const [chave, codigo] of Object.entries(dicionarioFornecedores)) {
      if (fornecedorNormalizado.includes(chave)) {
        console.log(`✅ Match parcial: "${fornecedorNormalizado}" contém "${chave}" -> Código ${codigo}`);
        return codigo;
      }
    }
    
    // Se não encontrar, retornar 0 (padrão)
    console.log(`⚠️ Fornecedor não encontrado no dicionário: "${fornecedorNormalizado}"`);
    return 0;
  };

  const auditarFornecedoresDoDicionario = () => {
    if (!csvData.length) {
      alert('Faça upload do CSV bruto antes de auditar.');
      return;
    }

    const chaves = Object.keys(dicionarioFornecedores)
      .map((k) => ({
        chaveOriginal: k,
        chaveNormalizada: normalizarFornecedorParaMatch(k),
        codigo: dicionarioFornecedores[k]
      }))
      .filter((k) => k.codigo !== 0);

    const totalLinhas = csvData.length;
    let linhasComFornecedorQueBateNoDict = 0;
    let linhasComMatchOK = 0;
    let linhasComFalhaContaZero = 0;

    const falhas = [];
    const ok = {};

    csvData.forEach((row, index) => {
      const fornecedorRaw = row.nomeFornecedor || '';
      const fornecedorNorm = normalizarFornecedorParaMatch(fornecedorRaw);

      if (!fornecedorNorm) {
        return;
      }

      const candidatos = chaves.filter(({ chaveNormalizada }) => {
        return fornecedorNorm === chaveNormalizada || fornecedorNorm.includes(chaveNormalizada);
      });

      if (!candidatos.length) {
        return;
      }

      linhasComFornecedorQueBateNoDict += 1;

      const contaDebito = determinarContaDebito(row.nomeFornecedor, row.categoria1, row.descricao);
      if (contaDebito && contaDebito !== 0) {
        linhasComMatchOK += 1;
        const chave = candidatos[0].chaveOriginal;
        ok[chave] = (ok[chave] || 0) + 1;
        return;
      }

      linhasComFalhaContaZero += 1;
      falhas.push({
        linha: index + 1,
        fornecedor: fornecedorRaw,
        fornecedorNormalizado: fornecedorNorm,
        candidatos: candidatos.slice(0, 5).map((c) => ({
          chave: c.chaveOriginal,
          codigo: c.codigo
        })),
        categoria: row.categoria1 || '',
        descricao: row.descricao || '',
        setor: row.centroCusto1 || ''
      });
    });

    setAuditoriaFornecedoresDict({
      totalLinhas,
      linhasComFornecedorQueBateNoDict,
      linhasComMatchOK,
      linhasComFalhaContaZero,
      ok,
      falhas
    });
  };

  const determinarContaCredito = (contaBancaria) => {
    const contaNormalizada = removerAcentosEMaiusculo(contaBancaria || '');
    
    if (!contaNormalizada) {
      return 18;
    }
    
    if (contaNormalizada.includes('PRIMEPAG')) {
      return 18;
    }
    
    if (
      contaNormalizada.includes('C6BANK') ||
      contaNormalizada.includes('C6 BANK') ||
      contaNormalizada.includes(' C6 ')
    ) {
      return 19;
    }
    
    return 18;
  };

  // Função para gerar CSV formatado
  const gerarCSVFormatado = () => {
    if (!csvData.length) {
      alert('Por favor, faça upload do arquivo CSV.');
      return;
    }

    const linhasCSV = [];
    let linhasProcessadas = 0;

    console.log('📄 GERANDO CSV DESPESAS FORMATADO:');
    console.log('📊 Total de registros:', csvData.length);
    
    csvData.forEach((row, index) => {
      const dataFormatada = formatarDataCSV(row.dataMovimento);
      
      // Determinar código da conta débito baseado no fornecedor, categoria e descrição
      const contaDebito = determinarContaDebito(row.nomeFornecedor, row.categoria1, row.descricao);
      const contaCredito = determinarContaCredito(row.contaBancaria);
      
      const valor = Math.abs(row.valor).toFixed(2); // Valor positivo em formato float
      const zero = 0;
      
      // Montar descrição conforme especificação
      const fornecedor = removerAcentosEMaiusculo(row.nomeFornecedor || 'NAO INFORMADO');
      const descricaoItem = removerAcentosEMaiusculo(row.descricao || 'NAO INFORMADO');
      const categoria = removerAcentosEMaiusculo(row.categoria1 || 'NAO INFORMADO');
      const setor = removerAcentosEMaiusculo(row.centroCusto1 || 'NAO INFORMADO');
      
      const descricao = `"FORNECEDOR: ${fornecedor} - DESCRICAO: ${descricaoItem} - CATEGORIA: ${categoria} - SETOR: ${setor}"`;

      // Formato: Data,ContaDebito,ContaCredito,Valor,Zero,Descrição
      const linha = `${dataFormatada},${contaDebito},${contaCredito},${valor},${zero},${descricao}`;
      linhasCSV.push(linha);
      linhasProcessadas++;
      
      if (index < 5) {
        console.log(`📄 Linha ${index + 1}:`, {
          data: dataFormatada,
          fornecedor: fornecedor.substring(0, 30) + '...',
          contaDebito: contaDebito,
          contaCredito: contaCredito,
          valor: valor,
          setor: setor
        });
      }
    });

    console.log('📄 CSV gerado com', linhasProcessadas, 'linhas');

    // Armazenar dados do CSV gerado para conciliação
    const dadosCSV = csvData.map((row) => ({
      data: row.dataMovimento,
      valor: Math.abs(row.valor),
      fornecedor: row.nomeFornecedor,
      descricao: row.descricao
    }));
    
    setCsvGerado({
      linhas: linhasCSV,
      dados: dadosCSV,
      totalValor: dadosCSV.reduce((sum, item) => sum + item.valor, 0)
    });

    // Criar e baixar o arquivo CSV
    const csvContent = linhasCSV.join('\n');
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `DESPESAS GERAL LANÇAMENTOS CSV QUESTOR ${extrairCompetencia()}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  // Função para processar arquivo OFX
  const processarOFX = (conteudo) => {
    console.log('📄 Processando arquivo OFX...');
    
    const transacoes = [];
    const regex = /<STMTTRN>([\s\S]*?)<\/STMTTRN>/g;
    let match;
    
    while ((match = regex.exec(conteudo)) !== null) {
      const transacao = match[1];
      
      // Extrair campos da transação
      const valorMatch = transacao.match(/<TRNAMT>([-\d.]+)<\/TRNAMT>/);
      const dataMatch = transacao.match(/<DTPOSTED>(\d{8})/);
      const tipoMatch = transacao.match(/<TRNTYPE>(\w+)<\/TRNTYPE>/);
      const memoMatch = transacao.match(/<MEMO>(.*?)<\/MEMO>/);
      
      if (valorMatch && dataMatch) {
        const valor = Math.abs(parseFloat(valorMatch[1]));
        const tipo = tipoMatch ? tipoMatch[1] : '';
        const memo = memoMatch ? memoMatch[1].trim() : '';
        
        // Converter data YYYYMMDD para DD/MM/YYYY
        const dataStr = dataMatch[1];
        const ano = dataStr.substring(0, 4);
        const mes = dataStr.substring(4, 6);
        const dia = dataStr.substring(6, 8);
        const dataFormatada = `${dia}/${mes}/${ano}`;
        
        // Processar apenas débitos (despesas)
        if (tipo === 'DEBIT') {
          transacoes.push({
            data: dataFormatada,
            valor: valor,
            tipo: tipo,
            memo: memo
          });
        }
      }
    }
    
    console.log(`✅ OFX processado: ${transacoes.length} transações de débito encontradas`);
    
    const totalOFX = transacoes.reduce((sum, t) => sum + t.valor, 0);
    
    setOfxData({
      transacoes: transacoes,
      totalValor: totalOFX
    });
    
    return { transacoes, totalValor: totalOFX };
  };

  // Função para realizar conciliação bancária
  const realizarConciliacao = () => {
    if (!csvGerado || !ofxData) {
      alert('Por favor, gere o CSV e faça upload do arquivo OFX primeiro.');
      return;
    }
    
    console.log('🔍 INICIANDO CONCILIAÇÃO BANCÁRIA');
    console.log('📊 Total CSV:', csvGerado.totalValor.toFixed(2));
    console.log('🏦 Total OFX:', ofxData.totalValor.toFixed(2));
    
    const diferencaTotal = Math.abs(csvGerado.totalValor - ofxData.totalValor);
    const percentualDiferenca = (diferencaTotal / ofxData.totalValor) * 100;
    
    // Encontrar transações correspondentes
    const correspondencias = [];
    const csvNaoConciliado = [];
    const ofxNaoConciliado = [];
    
    const csvUsado = new Set();
    const ofxUsado = new Set();
    
    // Tentar encontrar correspondências exatas por valor
    csvGerado.dados.forEach((csvItem, csvIndex) => {
      ofxData.transacoes.forEach((ofxItem, ofxIndex) => {
        if (!csvUsado.has(csvIndex) && !ofxUsado.has(ofxIndex)) {
          const diferencaValor = Math.abs(csvItem.valor - ofxItem.valor);
          
          // Correspondência exata (diferença menor que 0.01)
          if (diferencaValor < 0.01) {
            correspondencias.push({
              csv: csvItem,
              ofx: ofxItem,
              diferenca: diferencaValor
            });
            csvUsado.add(csvIndex);
            ofxUsado.add(ofxIndex);
          }
        }
      });
    });
    
    // Identificar não conciliados
    csvGerado.dados.forEach((item, index) => {
      if (!csvUsado.has(index)) {
        csvNaoConciliado.push(item);
      }
    });
    
    ofxData.transacoes.forEach((item, index) => {
      if (!ofxUsado.has(index)) {
        ofxNaoConciliado.push(item);
      }
    });
    
    const resultado = {
      totalCSV: csvGerado.totalValor,
      totalOFX: ofxData.totalValor,
      diferencaTotal: diferencaTotal,
      percentualDiferenca: percentualDiferenca,
      correspondencias: correspondencias,
      csvNaoConciliado: csvNaoConciliado,
      ofxNaoConciliado: ofxNaoConciliado,
      taxaConciliacao: (correspondencias.length / Math.max(csvGerado.dados.length, ofxData.transacoes.length)) * 100
    };
    
    console.log('✅ CONCILIAÇÃO CONCLUÍDA');
    console.log(`📊 Correspondências: ${correspondencias.length}`);
    console.log(`❌ CSV não conciliado: ${csvNaoConciliado.length}`);
    console.log(`❌ OFX não conciliado: ${ofxNaoConciliado.length}`);
    console.log(`💰 Diferença total: R$ ${diferencaTotal.toFixed(2)} (${percentualDiferenca.toFixed(2)}%)`);
    
    setConciliacaoResultado(resultado);
  };

  const realizarAuditoriaCsv = () => {
    if (!csvAuditoriaBase || !csvAuditoriaIA) {
      alert('Faça upload do CSV gerado e do CSV reescrito pela IA para auditar.');
      return;
    }

    const baseMap = new Map();
    const baseMapDescricao = new Map();
    csvAuditoriaBase.transacoes.forEach((item, index) => {
      const chaveValor = `${item.dataKey}|${item.valorAbs}`;
      const listaValor = baseMap.get(chaveValor) || [];
      listaValor.push(index);
      baseMap.set(chaveValor, listaValor);

      const chaveDescricao = `${item.dataKey}|${item.valorAbs}|${item.descricaoNormalizada}`;
      const listaDescricao = baseMapDescricao.get(chaveDescricao) || [];
      listaDescricao.push(index);
      baseMapDescricao.set(chaveDescricao, listaDescricao);
    });

    const usadosBase = new Set();
    const correspondencias = [];
    const somenteIA = [];

    csvAuditoriaIA.transacoes.forEach((item) => {
      let indiceMatch = null;
      const chaveDescricao = `${item.dataKey}|${item.valorAbs}|${item.descricaoNormalizada}`;
      const listaDescricao = baseMapDescricao.get(chaveDescricao) || [];
      while (listaDescricao.length) {
        const indice = listaDescricao.shift();
        if (!usadosBase.has(indice)) {
          indiceMatch = indice;
          break;
        }
      }

      if (indiceMatch === null) {
        const chaveValor = `${item.dataKey}|${item.valorAbs}`;
        const listaValor = baseMap.get(chaveValor) || [];
        while (listaValor.length) {
          const indice = listaValor.shift();
          if (!usadosBase.has(indice)) {
            indiceMatch = indice;
            break;
          }
        }
      }

      if (indiceMatch !== null) {
        usadosBase.add(indiceMatch);
        correspondencias.push({
          base: csvAuditoriaBase.transacoes[indiceMatch],
          ia: item
        });
      } else {
        somenteIA.push(item);
      }
    });

    const somenteBase = csvAuditoriaBase.transacoes.filter((_, index) => !usadosBase.has(index));
    const diferencaTotal = Math.abs(csvAuditoriaBase.totalValor - csvAuditoriaIA.totalValor);
    const taxaConciliacao = (correspondencias.length / Math.max(csvAuditoriaBase.transacoes.length, csvAuditoriaIA.transacoes.length)) * 100;

    setAuditoriaCsvResultado({
      totalBase: csvAuditoriaBase.totalValor,
      totalIA: csvAuditoriaIA.totalValor,
      diferencaTotal,
      correspondencias,
      somenteBase,
      somenteIA,
      taxaConciliacao
    });
  };

  // Função para lidar com upload do arquivo OFX
  const handleOFXUpload = (file) => {
    if (!file) return;
    
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const conteudo = e.target.result;
        processarOFX(conteudo);
        alert('Arquivo OFX processado com sucesso!');
      } catch (error) {
        console.error('Erro ao processar OFX:', error);
        alert('Erro ao processar arquivo OFX. Verifique o formato do arquivo.');
      }
    };
    reader.readAsText(file);
  };

  const handleOFXSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleOFXUpload(file);
    }
  };

  // Função para lidar com upload de arquivo
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleFileUpload(file);
    }
  };

  const handleFileUpload = (file) => {
    if (!file.name.toLowerCase().endsWith('.csv')) {
      alert('Por favor, selecione um arquivo CSV válido.');
      return;
    }

    setIsProcessing(true);
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const content = e.target.result;
        
        // Debug: verificar algumas linhas do conteúdo bruto
        const linhasAmostra = content.split('\n').slice(0, 3);
        console.log('🔍 Amostra do conteúdo bruto:', linhasAmostra);
        
        const { data, totalGeral } = processCSV(content);
        
        setCsvData(data);
        setSummary({
          totalRegistros: data.length,
          totalGeral: totalGeral
        });
        
        console.log('✅ Arquivo processado com sucesso!');
      } catch (error) {
        console.error('❌ Erro ao processar arquivo:', error);
        alert('Erro ao processar o arquivo CSV. Verifique o formato.');
      } finally {
        setIsProcessing(false);
      }
    };
    
    // Lendo arquivo com encoding UTF-8
    console.log('📄 Lendo arquivo com encoding UTF-8');
    reader.readAsText(file, 'UTF-8');
  };

  // Drag and drop handlers
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      handleFileUpload(files[0]);
    }
  };

  const calcularResumoBancos = () => {
    if (!csvData.length) {
      return { primepag: 0, c6: 0, totalPrimepag: 0, totalC6: 0 };
    }

    let primepag = 0;
    let c6 = 0;
    let totalPrimepag = 0;
    let totalC6 = 0;

    csvData.forEach((row) => {
      const contaNormalizada = removerAcentosEMaiusculo(row.contaBancaria || '');
      const valorAbs = Math.abs(row.valor || 0);

      if (contaNormalizada.includes('C6 BANK') || contaNormalizada.includes('C6BANK')) {
        c6++;
        totalC6 += valorAbs;
      } else if (contaNormalizada.includes('PRIMEPAG')) {
        primepag++;
        totalPrimepag += valorAbs;
      }
    });

    return { primepag, c6, totalPrimepag, totalC6 };
  };

  const { primepag, c6, totalPrimepag, totalC6 } = calcularResumoBancos();

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-6xl mx-auto">
        {/* Cabeçalho */}
        <div className="mb-8">
          <div className="flex items-center gap-4 mb-4">
            <Link to={createPageUrl("Operations")}>
              <Button variant="outline" size="sm" className="flex items-center gap-2">
                <ArrowLeft className="w-4 h-4" />
                Voltar para Operações
              </Button>
            </Link>
          </div>
          
          <div className="flex items-center gap-4">
            <div className="p-3 bg-red-100 rounded-xl">
              <CreditCard className="w-8 h-8 text-red-600" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Despesas Geral - Zendry</h1>
              <p className="text-gray-600 mt-1">Processamento e análise de despesas gerais do sistema Zendry</p>
            </div>
          </div>
        </div>

        {/* Upload de Arquivo */}
        <Card className="mb-8">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Upload className="w-5 h-5" />
              Upload do Arquivo CSV
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div 
              className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center hover:border-red-400 transition-colors cursor-pointer"
              onDragOver={handleDragOver}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current?.click()}
            >
              <div className="flex flex-col items-center gap-4">
                <div className="p-4 bg-red-100 rounded-full">
                  <FileText className="w-8 h-8 text-red-600" />
                </div>
                <div>
                  <p className="text-lg font-medium text-gray-900">
                    {isProcessing ? 'Processando arquivo...' : 'Arraste e solte o arquivo CSV aqui'}
                  </p>
                  <p className="text-gray-500 mt-1">
                    ou clique para selecionar o arquivo
                  </p>
                </div>
                <Button 
                  variant="outline" 
                  className="flex items-center gap-2"
                  disabled={isProcessing}
                >
                  <Upload className="w-4 h-4" />
                  Selecionar Arquivo
                </Button>
              </div>
            </div>
            <input
              ref={fileInputRef}
              type="file"
              accept=".csv"
              onChange={handleFileSelect}
              className="hidden"
            />
          </CardContent>
        </Card>

        {/* Resumo e Análise */}
        {summary && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            {/* Cards de Resumo */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <Card className="bg-red-50 border-red-200">
                <CardContent className="p-6">
                  <div>
                    <p className="text-red-600 text-sm font-medium">Total de Despesas</p>
                    <p className="text-2xl font-bold text-red-700">
                      {formatCurrency(summary.totalGeral)}
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-gray-50 border-gray-200">
                <CardContent className="p-6">
                  <div>
                    <p className="text-gray-600 text-sm font-medium">Total de Lançamentos</p>
                    <p className="text-2xl font-bold text-gray-700">
                      {summary.totalRegistros}
                    </p>
                  </div>
                </CardContent>
              </Card>

              <Card className="bg-blue-50 border-blue-200">
                <CardContent className="p-6">
                  <div>
                    <p className="text-blue-600 text-sm font-medium">Setores Ativos</p>
                    <p className="text-2xl font-bold text-blue-700">
                      {calcularTotaisPorSetor().length}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </div>

            {/* Botão de Download */}
            <div className="flex gap-4 mb-8">
              <Button 
                onClick={gerarCSVFormatado} 
                className="flex items-center gap-2 bg-red-600 hover:bg-red-700"
              >
                <Download className="w-4 h-4" />
                Baixar CSV Formatado
              </Button>
              <Button 
                onClick={auditarFornecedoresDoDicionario}
                variant="outline"
                className="flex items-center gap-2"
              >
                <FileText className="w-4 h-4" />
                Auditar Fornecedores do Dicionário
              </Button>
            </div>

            {auditoriaFornecedoresDict && (
              <Card className="mb-8 border-amber-200">
                <CardHeader className="bg-amber-50">
                  <CardTitle className="flex items-center gap-2 text-amber-900">
                    <FileText className="w-5 h-5" />
                    Auditoria - Fornecedores já presentes no dicionário
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <Card className="border-gray-200">
                      <CardContent className="p-4">
                        <p className="text-xs text-gray-600">Total de Linhas</p>
                        <p className="text-xl font-bold text-gray-800">{auditoriaFornecedoresDict.totalLinhas}</p>
                      </CardContent>
                    </Card>
                    <Card className="border-gray-200">
                      <CardContent className="p-4">
                        <p className="text-xs text-gray-600">Linhas com fornecedor que bate no dicionário</p>
                        <p className="text-xl font-bold text-gray-800">{auditoriaFornecedoresDict.linhasComFornecedorQueBateNoDict}</p>
                      </CardContent>
                    </Card>
                    <Card className="border-green-200 bg-green-50">
                      <CardContent className="p-4">
                        <p className="text-xs text-green-800">Match OK (conta != 0)</p>
                        <p className="text-xl font-bold text-green-900">{auditoriaFornecedoresDict.linhasComMatchOK}</p>
                      </CardContent>
                    </Card>
                    <Card className="border-red-200 bg-red-50">
                      <CardContent className="p-4">
                        <p className="text-xs text-red-800">Falhas (conta = 0)</p>
                        <p className="text-xl font-bold text-red-900">{auditoriaFornecedoresDict.linhasComFalhaContaZero}</p>
                      </CardContent>
                    </Card>
                  </div>

                  {auditoriaFornecedoresDict.falhas.length > 0 && (
                    <div className="space-y-2">
                      <p className="text-sm font-medium text-gray-700">Primeiras falhas (até 15):</p>
                      <div className="border rounded-md bg-white p-3 overflow-auto max-h-96">
                        <pre className="text-xs whitespace-pre-wrap">
{JSON.stringify(auditoriaFornecedoresDict.falhas.slice(0, 15), null, 2)}
                        </pre>
                      </div>
                    </div>
                  )}
                </CardContent>
              </Card>
            )}

            {/* Auditoria CSV gerado x CSV IA */}
            <Card className="mb-8 border-blue-200">
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-blue-700">
                  <FileText className="w-5 h-5" />
                  Auditoria CSV Gerado x CSV IA
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Upload CSV gerado na página</label>
                    <div
                      className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:border-blue-400"
                      onClick={() => csvAuditoriaBaseRef.current?.click()}
                    >
                      <p className="text-sm text-gray-600">Clique para selecionar o CSV gerado</p>
                      {csvAuditoriaBase && (
                        <p className="text-xs text-blue-700 mt-2">
                          {csvAuditoriaBase.transacoes.length} lançamentos carregados
                        </p>
                      )}
                    </div>
                    <input
                      ref={csvAuditoriaBaseRef}
                      type="file"
                      accept=".csv"
                      onChange={(e) => handleCSVAuditoriaBaseUpload(e.target.files[0])}
                      className="hidden"
                    />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">Upload CSV reescrito pela IA</label>
                    <div
                      className="border-2 border-dashed rounded-lg p-4 text-center cursor-pointer hover:border-blue-400"
                      onClick={() => csvAuditoriaIaRef.current?.click()}
                    >
                      <p className="text-sm text-gray-600">Clique para selecionar o CSV da IA</p>
                      {csvAuditoriaIA && (
                        <p className="text-xs text-blue-700 mt-2">
                          {csvAuditoriaIA.transacoes.length} lançamentos carregados
                        </p>
                      )}
                    </div>
                    <input
                      ref={csvAuditoriaIaRef}
                      type="file"
                      accept=".csv"
                      onChange={(e) => handleCSVAuditoriaIaUpload(e.target.files[0])}
                      className="hidden"
                    />
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  <Button
                    onClick={realizarAuditoriaCsv}
                    className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700"
                    disabled={!csvAuditoriaBase || !csvAuditoriaIA}
                  >
                    <Download className="w-4 h-4" />
                    Auditar CSVs
                  </Button>
                  <span className="text-sm text-gray-500 self-center">
                    {(!csvAuditoriaBase || !csvAuditoriaIA) ? 'Carregue os dois CSVs para auditar.' : 'Pronto para auditar.'}
                  </span>
                </div>

                {auditoriaCsvResultado && (
                  <div className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                      <Card className="bg-blue-50 border-blue-200">
                        <CardContent className="p-4">
                          <p className="text-xs text-blue-700">Total CSV Gerado</p>
                          <p className="text-lg font-bold text-blue-800">
                            {formatCurrency(auditoriaCsvResultado.totalBase)}
                          </p>
                        </CardContent>
                      </Card>
                      <Card className="bg-green-50 border-green-200">
                        <CardContent className="p-4">
                          <p className="text-xs text-green-700">Total CSV IA</p>
                          <p className="text-lg font-bold text-green-800">
                            {formatCurrency(auditoriaCsvResultado.totalIA)}
                          </p>
                        </CardContent>
                      </Card>
                      <Card className="bg-red-50 border-red-200">
                        <CardContent className="p-4">
                          <p className="text-xs text-red-700">Diferença Total</p>
                          <p className="text-lg font-bold text-red-800">
                            {formatCurrency(auditoriaCsvResultado.diferencaTotal)}
                          </p>
                        </CardContent>
                      </Card>
                      <Card className="bg-purple-50 border-purple-200">
                        <CardContent className="p-4">
                          <p className="text-xs text-purple-700">Taxa de Conciliação</p>
                          <p className="text-lg font-bold text-purple-800">
                            {auditoriaCsvResultado.taxaConciliacao.toFixed(1)}%
                          </p>
                        </CardContent>
                      </Card>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <Card>
                        <CardHeader>
                          <div className="flex items-center justify-between">
                            <CardTitle className="text-sm text-blue-700">Somente no CSV Gerado</CardTitle>
                            <Button
                              variant="outline"
                              size="sm"
                              className="text-xs"
                              onClick={() => copiarListaDivergencias(auditoriaCsvResultado.somenteBase)}
                              disabled={!auditoriaCsvResultado.somenteBase.length}
                            >
                              <Copy className="w-3 h-3 mr-1" />
                              Copiar
                            </Button>
                          </div>
                        </CardHeader>
                        <CardContent className="space-y-2 max-h-72 overflow-y-auto">
                          {auditoriaCsvResultado.somenteBase.map((item, idx) => (
                            <div key={`csv-base-${idx}`} className="p-2 bg-blue-50 rounded-lg text-xs">
                              <p className="font-semibold">{item.data} • {formatCurrency(item.valorAbs)}</p>
                              <p className="text-gray-600">{item.descricao}</p>
                            </div>
                          ))}
                          {!auditoriaCsvResultado.somenteBase.length && (
                            <p className="text-xs text-gray-500">Nenhuma divergência encontrada no CSV gerado.</p>
                          )}
                        </CardContent>
                      </Card>

                      <Card>
                        <CardHeader>
                          <div className="flex items-center justify-between">
                            <CardTitle className="text-sm text-orange-700">Somente no CSV IA</CardTitle>
                            <Button
                              variant="outline"
                              size="sm"
                              className="text-xs"
                              onClick={() => copiarListaDivergencias(auditoriaCsvResultado.somenteIA)}
                              disabled={!auditoriaCsvResultado.somenteIA.length}
                            >
                              <Copy className="w-3 h-3 mr-1" />
                              Copiar
                            </Button>
                          </div>
                        </CardHeader>
                        <CardContent className="space-y-2 max-h-72 overflow-y-auto">
                          {auditoriaCsvResultado.somenteIA.map((item, idx) => (
                            <div key={`csv-ia-${idx}`} className="p-2 bg-orange-50 rounded-lg text-xs">
                              <p className="font-semibold">{item.data} • {formatCurrency(item.valorAbs)}</p>
                              <p className="text-gray-600">{item.descricao}</p>
                            </div>
                          ))}
                          {!auditoriaCsvResultado.somenteIA.length && (
                            <p className="text-xs text-gray-500">Nenhuma divergência encontrada no CSV IA.</p>
                          )}
                        </CardContent>
                      </Card>
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>

            {/* Conciliação Bancária - Apenas para C6 Bank */}
            {c6 > 0 && csvGerado && (
              <Card className="mb-8 border-purple-200">
                <CardHeader className="bg-purple-50">
                  <CardTitle className="flex items-center gap-2 text-purple-900">
                    <CreditCard className="w-5 h-5" />
                    Conciliação Bancária - C6 Bank
                  </CardTitle>
                </CardHeader>
                <CardContent className="p-6">
                  <div className="space-y-4">
                    <p className="text-sm text-gray-600">
                      Faça upload do arquivo OFX do extrato do C6 Bank para comparar com o CSV gerado e validar os valores.
                    </p>
                    
                    {/* Upload OFX */}
                    <div className="flex gap-4 items-center">
                      <Button
                        onClick={() => ofxInputRef.current?.click()}
                        variant="outline"
                        className="flex items-center gap-2 border-purple-300 hover:bg-purple-50"
                      >
                        <Upload className="w-4 h-4" />
                        {ofxData ? 'Arquivo OFX Carregado ✓' : 'Upload Arquivo OFX'}
                      </Button>
                      
                      {ofxData && (
                        <Button
                          onClick={realizarConciliacao}
                          className="flex items-center gap-2 bg-purple-600 hover:bg-purple-700"
                        >
                          <CreditCard className="w-4 h-4" />
                          Realizar Conciliação
                        </Button>
                      )}
                    </div>
                    
                    <input
                      ref={ofxInputRef}
                      type="file"
                      accept=".ofx"
                      onChange={handleOFXSelect}
                      className="hidden"
                    />
                    
                    {/* Informações OFX */}
                    {ofxData && (
                      <div className="grid grid-cols-2 gap-4 p-4 bg-purple-50 rounded-lg">
                        <div>
                          <p className="text-sm text-purple-700 font-medium">Transações OFX (Débitos)</p>
                          <p className="text-xl font-bold text-purple-900">{ofxData.transacoes.length}</p>
                        </div>
                        <div>
                          <p className="text-sm text-purple-700 font-medium">Total OFX</p>
                          <p className="text-xl font-bold text-purple-900">{formatCurrency(ofxData.totalValor)}</p>
                        </div>
                      </div>
                    )}
                    
                    {/* Resultado da Conciliação */}
                    {conciliacaoResultado && (
                      <div className="mt-6 space-y-4">
                        <h3 className="font-bold text-lg text-gray-900">Resultado da Conciliação</h3>
                        
                        {/* Resumo */}
                        <div className="grid grid-cols-3 gap-4">
                          <Card className={conciliacaoResultado.percentualDiferenca < 1 ? 'bg-green-50 border-green-200' : 'bg-yellow-50 border-yellow-200'}>
                            <CardContent className="p-4">
                              <p className="text-sm font-medium text-gray-700">Taxa de Conciliação</p>
                              <p className="text-2xl font-bold text-gray-900">
                                {conciliacaoResultado.taxaConciliacao.toFixed(1)}%
                              </p>
                            </CardContent>
                          </Card>
                          
                          <Card className="bg-blue-50 border-blue-200">
                            <CardContent className="p-4">
                              <p className="text-sm font-medium text-gray-700">Correspondências</p>
                              <p className="text-2xl font-bold text-gray-900">
                                {conciliacaoResultado.correspondencias.length}
                              </p>
                            </CardContent>
                          </Card>
                          
                          <Card className={conciliacaoResultado.diferencaTotal < 100 ? 'bg-green-50 border-green-200' : 'bg-red-50 border-red-200'}>
                            <CardContent className="p-4">
                              <p className="text-sm font-medium text-gray-700">Diferença Total</p>
                              <p className="text-2xl font-bold text-gray-900">
                                {formatCurrency(conciliacaoResultado.diferencaTotal)}
                              </p>
                              <p className="text-xs text-gray-600">
                                ({conciliacaoResultado.percentualDiferenca.toFixed(2)}%)
                              </p>
                            </CardContent>
                          </Card>
                        </div>
                        
                        {/* Detalhes */}
                        <div className="grid grid-cols-2 gap-4">
                          {/* CSV Não Conciliado */}
                          {conciliacaoResultado.csvNaoConciliado.length > 0 && (
                            <Card className="border-orange-200">
                              <CardHeader className="bg-orange-50">
                                <CardTitle className="text-sm">CSV Não Conciliado ({conciliacaoResultado.csvNaoConciliado.length})</CardTitle>
                              </CardHeader>
                              <CardContent className="p-4 max-h-60 overflow-y-auto">
                                <div className="space-y-2">
                                  {conciliacaoResultado.csvNaoConciliado.slice(0, 10).map((item, idx) => (
                                    <div key={idx} className="text-xs p-2 bg-orange-50 rounded">
                                      <p className="font-medium">{item.fornecedor}</p>
                                      <p className="text-gray-600">{formatCurrency(item.valor)} - {item.data}</p>
                                    </div>
                                  ))}
                                  {conciliacaoResultado.csvNaoConciliado.length > 10 && (
                                    <p className="text-xs text-gray-500 italic">
                                      +{conciliacaoResultado.csvNaoConciliado.length - 10} mais...
                                    </p>
                                  )}
                                </div>
                              </CardContent>
                            </Card>
                          )}
                          
                          {/* OFX Não Conciliado */}
                          {conciliacaoResultado.ofxNaoConciliado.length > 0 && (
                            <Card className="border-red-200">
                              <CardHeader className="bg-red-50">
                                <CardTitle className="text-sm">OFX Não Conciliado ({conciliacaoResultado.ofxNaoConciliado.length})</CardTitle>
                              </CardHeader>
                              <CardContent className="p-4 max-h-60 overflow-y-auto">
                                <div className="space-y-2">
                                  {conciliacaoResultado.ofxNaoConciliado.slice(0, 10).map((item, idx) => (
                                    <div key={idx} className="text-xs p-2 bg-red-50 rounded">
                                      <p className="font-medium">{item.memo}</p>
                                      <p className="text-gray-600">{formatCurrency(item.valor)} - {item.data}</p>
                                    </div>
                                  ))}
                                  {conciliacaoResultado.ofxNaoConciliado.length > 10 && (
                                    <p className="text-xs text-gray-500 italic">
                                      +{conciliacaoResultado.ofxNaoConciliado.length - 10} mais...
                                    </p>
                                  )}
                                </div>
                              </CardContent>
                            </Card>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </CardContent>
              </Card>
            )}

            {/* Análise por Setores */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              {/* Totais por Setor */}
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <TrendingDown className="w-5 h-5" />
                    Despesas por Setor
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  {calcularTotaisPorSetor().map((item, index) => (
                    <div key={item.setor} className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                      <div>
                        <span className="font-medium text-gray-900">{item.setor}</span>
                        <p className="text-sm text-gray-600">{item.percentual.toFixed(1)}% do total</p>
                      </div>
                      <span className="font-bold text-red-700">
                        {formatCurrency(item.valor)}
                      </span>
                    </div>
                  ))}
                </CardContent>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="flex items-center gap-2">
                    <FileText className="w-5 h-5" />
                    Informações do Processamento
                  </CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <div className="flex justify-between items-center p-3 bg-blue-50 rounded-lg">
                    <span className="text-blue-700 font-medium">Registros Processados:</span>
                    <span className="text-blue-800 font-bold">
                      {csvData.length} linhas
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-yellow-50 rounded-lg">
                    <span className="text-yellow-700 font-medium">Lançamentos PrimePag:</span>
                    <span className="text-yellow-800 font-bold">
                      {primepag} ({formatCurrency(totalPrimepag)})
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-purple-50 rounded-lg">
                    <span className="text-purple-700 font-medium">Lançamentos C6 Bank:</span>
                    <span className="text-purple-800 font-bold">
                      {c6} ({formatCurrency(totalC6)})
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-green-50 rounded-lg">
                    <span className="text-green-700 font-medium">Competência:</span>
                    <span className="text-green-800 font-bold">
                      {extrairCompetencia()}
                    </span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-gray-50 rounded-lg">
                    <span className="text-gray-700 font-medium">Formato de Saída:</span>
                    <span className="text-gray-800 font-bold">
                      CSV Questor
                    </span>
                  </div>
                </CardContent>
              </Card>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
